import { WidgetService } from './dashboards/services/widget.service';
import { ObservationService } from './observations/services/observation.service';
import { CategoryService } from './observations/services/category.service';
import { KpiService } from './kpis/services/kpi.service';
import { KpiSetService } from './kpis/services/kpi-set.service';
import { WorkLogService } from './work-logs/services/work-log.service';
import { KpiSetKpiService } from './kpis/services/kpi-set-kpi.service';
import { LocationObservationService } from './observations/services/location-observation.service';
import { KpiSetTenantService } from './kpis/services/kpi-set-tenant.service';
import { TenantLocationService } from './locations/services/tenant-location.service';
import { UrgentObservationService } from './dashboards/widgets/urgent-observations/services/urgent-observation.service';

export const Services = [
    WidgetService,
    ObservationService,
    CategoryService,
    KpiService,
    KpiSetService,
    WorkLogService,
    KpiSetKpiService,
    LocationObservationService,
    KpiSetTenantService,
    TenantLocationService,
    UrgentObservationService,
];



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/services.ts